<template>
  <div class="container">
    <!-- 编号盒子 -->
    <div 
      v-for="(num, index) in numbers" 
      :key="index" 
      class="item"
      :class="{ 'item1': activeBox === num,  // 优先判断是否是当前选中
        'error-item': activeBox !== num && isErrorQuestion(num) }"  
      @click="selectBox(num)"  
    >
      {{ num }}
    </div>
    
    <!-- +号盒子 -->
    <div 
    v-if="show !== 1"
      class="item add-box" 
      @click="tryAddBox"
    >
      +
    </div>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0
    },
      show: {
      type: Number,
      default: 0
    },
    activeBox: {  // 当前选中的盒子编号
      type: Number,
      default: 0
    },
        currentContent: String,
        errorQuestionss: {  // 新增prop，接收错误题目的编号数组
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      numbers: [] ,// 存储编号的数组，初始为空
      
    }
  },
  methods: {
     isErrorQuestion(num) {
      return this.errorQuestionss.includes(num);
    },
    tryAddBox() {
      this.$emit('add-box');
      
    },
    
    selectBox(index) {
      this.$emit('switch-form', index);
    },
    
    updateNumbers(count) {
      this.numbers = Array.from({length: count}, (_, i) => i + 1);
    },
    
    addBox() {
      const newNum = this.numbers.length + 1;
      this.numbers.push(newNum);
      this.$emit('add-box', newNum);
      this.$emit('update:active-box', newNum);
    },
    
    removeBox(activeNum) {
      this.numbers = this.numbers.filter(num => num !== activeNum);
      this.numbers = this.numbers.map((num, index) => index + 1);
      this.$emit('update:active-box', this.numbers.length > 0 ? this.numbers[this.numbers.length - 1] : 0);
    },
  },
  watch: {
    count(newVal) {
      this.numbers = Array.from({length: newVal}, (_, i) => i + 1);
    }
  }
}
</script>

<style scoped>
.error-item {
  background: rgb(207, 2, 2) !important;
  color: white !important;
}

.active-error {
  background: rgb(207, 2, 2) !important;
  border: 2px solid #000;
}
/* 添加一些样式使表单更清晰 */
.question-form {
  margin-bottom: 20px;
  padding: 15px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fafafa;
}

.check-box {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-left: 10px;
  cursor: pointer;
  text-align: center;
  line-height: 20px;
}

.check-box.checked {
  background-color: #409eff;
  color: white;
}
.container {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 10px;
}

.item {
  width: calc((100% - 6 * 10px) / 7);
  height: 50px;
  background: rgba(237, 244, 251, 1);
  color: rgba(67, 67, 67, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  border: 1px solid rgba(130, 145, 169, 1);
}

.add-box {
  background: rgba(237, 244, 251, 1);
  color: rgb(23, 21, 21);
  cursor: pointer;
}

.add-box:hover {
  transform: scale(1.05);
}

.add-box:active {
  transform: scale(0.98);
}

.item1 {
   background: rgb(64, 158, 255);
  /* background: rgba(247, 69, 69, 1); */
  color: white;
}

.box:hover {
  transform: scale(1.05);
}

.box:active {
  transform: scale(0.98);
}
</style>